import Parser from '@/services/adhocParser';

export default {
  state: {
    views: []
  },
  getters: {
    getViews: state => state.views,
    getMatchingView: (state, getters) => (plan) => {
      // find highest suitable floor
      const highestFloor = getters.getPlanHighestFloor(plan.id);
      let planView = state.views.find(view =>
        view.floor < highestFloor &&
        plan.exposure.indexOf(view.dir) > -1
      );

      // use lowest floor if no suitable view is found
      if (!planView) {
        planView = state.views.find(view =>
          view.floor === view[0].floor &&
          plan.exposure.indexOf(view.dir) > -1
        );
      }
      return planView;
    }
  },
  mutations: {
    setViews(state, payload) {
      state.views = payload;
      state.views.sort((a, b) => b.floor - a.floor); // desc
    }
  },
  actions: {
    PARSE_VIEWS({ commit }, payload) {
      const views = payload.find(section => section.section_name.toLowerCase() === 'views');
      if (views) {
        commit('setViews', Parser.parseViews(views.section_images));
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/Views.js